module.exports = __webpack_public_path__ + "media/images/fr/upload-advertorial-b7f3321c70e5409867ab7e93640773d6.png";